import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {stopLoading} from '../../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {ProfileDetailData} from '../../../../../Redux/AdminPanel/ProfileDetailsSlice'
import {fetchAsyncUserDetails} from '../../../../UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState: any = {
  assignedStaffList: [],
}

////////////////////////////////////ASSIGNEE USER LIST////////////////////////////////////////////

export const getAllAssigneeUser: any = createAsyncThunk(
  '/getAllAssigneeUser',
  async (data: any, thunkApi) => {
    const response: any = await axios.get(`${API_URL}admin/assignedUserListforSuperAdmin`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const UpdateAssigneTo: any = createAsyncThunk(
  '/UpdateAssigneTo',
  async (data: any, thunkApi) => {
    const response: any = await axios.post(`${API_URL}admin/assignedUserbySuperAdmin`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(getAllAssigneeUser({userId: data?.userId}))
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const deallocateStaff: any = createAsyncThunk(
  '/deallocateStaff',
  async (data: any, thunkApi) => {
    const response: any = await axios.post(`${API_URL}admin/unassignedUserbySuperAdmin`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(getAllAssigneeUser({userId: data?.userId}))
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const UpdateStatusForOwner: any = createAsyncThunk(
  '/updateStatusForOwner',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.post(`${API_URL}admin/updateStatus`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(ProfileDetailData(data?.userId))
    {
      response.data.status == true
        ? toast.success(response.data.message)
        : toast.error(response.data.message)
    }
    return response.data
  }
)
export const freeCreditToUser: any = createAsyncThunk(
  'freeCreditToUser',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.post(`${API_URL}admin/addFreeCreditsToUser`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(ProfileDetailData(data?.userId))
    thunkApi.dispatch(fetchAsyncUserDetails())
    {
      response.data.status == true
        ? toast.success(
            typeof response.data.data == 'string' ? response.data.data : 'Credit Added Successfully'
          )
        : toast.error(response.data.message)
    }
    return response.data
  }
)

const AssignedStaff = createSlice({
  name: 'AssignedStaff',
  initialState,
  reducers: {},
  extraReducers: {
    ////////////////////////////superadmin///////////////////////////////////////////////////////////////////
    [getAllAssigneeUser.fulfilled]: (state, {payload}) => {
      return {...state, assignedStaffList: payload.data}
    },
  },
})

export const getAllStaffAssignedToUserList = (state: any) => state.AssignedStaff.assignedStaffList

export default AssignedStaff.reducer
